export default "__VITE_ASSET__DIm0xZkX__"